
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import DbnpRegistriesComponent from './dbnp-registries.component';

export const DbnpBasicInfoComponent = ({id,selectedDbnp, handleInnerFormChange,organizationUnits}: any) => (
    <><AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name'
                )
              }}
              type="text"
              value={selectedDbnp?.Name}
          />
     <InputContainer
                    label="OrganizationUnit"
                    labelField="Name"
                    list={organizationUnits}
                    onValueChange={(event: any, newValue: any) => {
                        handleInnerFormChange(
                        event.target.value,
                        'OrganizationUnitId'
                       
                      );
                    }}
                    optionName="Choose OrganizationUnit"
                    type="select"
                    value={selectedDbnp?.OrganizationUnitId}
                    valueField="Id"
                  />
     <InputContainer
              label="RegisterWitheKYC"
              name="IsRegisterWitheKYC"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsRegisterWitheKYC'
                )
              }}
              type="checkbox"
              value={selectedDbnp?.IsRegisterWitheKYC}
          />
           <InputContainer
              label="RegisterWithOpenNetwork"
              name="IsRegisterWithOpenNetwork"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsRegisterWithOpenNetwork'
                )
              }}
              type="checkbox"
              value={selectedDbnp?.IsRegisterWithOpenNetwork}
          />
           <InputContainer
              label="JoinAsDBNConsumer"
              name="IsJoinAsDBNConsumer"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsJoinAsDBNConsumer'
                )
              }}
              type="checkbox"
              value={selectedDbnp?.IsJoinAsDBNConsumer}
          />
           <InputContainer
              label="JoinAsDBNProvider"
              name="IsJoinAsDBNProvider"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsJoinAsDBNProvider'
                )
              }}
              type="checkbox"
              value={selectedDbnp?.IsJoinAsDBNProvider}
          />
           <InputContainer
              label="JoinAsDBNVendor"
              name="IsJoinAsDBNVendor"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsJoinAsDBNVendor'
                )
              }}
              type="checkbox"
              value={selectedDbnp?.IsJoinAsDBNVendor}
          />
         <InputContainer
              label="JoinAsDBNSupplier"
              name="IsJoinAsDBNSupplier"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsJoinAsDBNSupplier'
                )
              }}
              type="checkbox"
              value={selectedDbnp?.IsJoinAsDBNSupplier}
          />
          <InputContainer
              label="JoingAsDBNPartner"
              name="IsJoingAsDBNPartner"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsJoingAsDBNPartner'
                )
              }}
              type="checkbox"
              value={selectedDbnp?.IsJoingAsDBNPartner}
          />
         {id == 0 &&<InputContainer
              label="Enable DBNP Registry"
              name="IsEnableDbnpRegistry"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsEnableDbnpRegistry'
                )
              }}
              type="checkbox"
              value={selectedDbnp?.IsEnableDbnpRegistry}
          />}
          {id != 0 && selectedDbnp?.IsEnableDbnpRegistry && <InputContainer
          isDisabled
              label="Enable DBNP Registry"
              name="IsEnableDbnpRegistry"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsEnableDbnpRegistry'
                )
              }}
              type="checkbox"
              value={selectedDbnp?.IsEnableDbnpRegistry}
          />}

 {/* {selectedDbnp?.IsEnableDBNPRegistry &&
 <div className='col-span-full'>
 <AccordionContainer
 child={
 <div className='col-span-full'>
 <DbnpRegistriesComponent
           handleInnerFormChange={handleInnerFormChange}
           handleFormChange={handleFormChange}
           selectedDbnpRegistry={selectedDbnpRegistry}
           opsnumber={opsnumber}
          domains={domains}
          subDomains={subDomains}
          countries={countries}
          id={id}
/>
 </div>
 
}
expandedPanel="DBN Registries Details"
headerTitle="DBN Registries Details"
/>
 </div>
 } */}


     </div>
    }
                  expandedPanel="Basic Info"
                  headerTitle="Basic Info"
                />
    </>
)